import request from './axios'

//
/**
 * 获取用户信息
 *
 * 示例：
 * 
 *   一、 async-await
 *
 *        async function getUserInfo () {
 *           try {
 *             const data = await getUserInfoApi()
 *           } catch (err) {
 *             // error handling
 *           }
 *         }
 *   二、.then
 *
 *     function getUserInfo () {
 *        getUserInfoApi.then(res => {
 *         //
 *       }).catch(err => {
 *         
 *       })
 *     }
 */
// export function getUserInfoApi () {
//   return request.get('/login')
// }
// export function loginApi (params) {
//   return request.post('/login',params)
// }

// 
// 登录 
export const loginApi = (params) => {
  return request({
    url: "/login",
    method: "post",
    data: params,
  });
};
// 退出登录
export const loginOut = (params) => {
  return request({
    url: "/loginOut",
    method: "get",
    params: params,
  });
};
//设备管理批量删除终端
export const DeleteDevice = (params) => {
  return request({
    url: "/initialize/batchDeleteDeviceInfo",
    method: "post",
    data: params,
  });
};
// 设备管理列表
export const deviceListFind = (params) => {
  return request({
    url: "/device/list/find",
    method: "post",
    data: params,
  });
};

//获取设备页面对应的按钮
export const getButtonList = (params =>{
  return request({
    url:"/menu/loadButtonByUserId",
    method:"get",
    params:params
  });
});

//批量切换服务
export const piliangDevice = (params) => {
  return request({
    url: `/device/batchSwitchingService`,
    method: "get",
    params
  });
};
//设备管理换机
export const deviceHuanji = (deviceId,imei,memberId) => {
  return request({
    url: `/device/changeImei?deviceId=${deviceId}&&imei=${imei}&&memberId=${memberId}`,
    method: "post",
  });
};
//设备管理解绑
export const deviceUnbind = (deviceId,memberId,userId) => {
  return request({
    url: `/device/unbind?deviceId=${deviceId}&&memberId=${memberId}&&userId=${userId}`,
    method: "post",
  });
};
// 远程关机 必传imei
export const deviceShutdown = (imei) => {
  return request({
    url: `/device/shutdown?imei=${imei}`,
    method: "get",
  });
};
//远程重启 必传imei
export const deviceRestart = (imei) => {
  return request({
    url: `/device/restart?imei=${imei}`,
    method: "get",
  });
};

// 设备管批量删除
export const deleteList = (params) => {
  return request({  
    url: `/device/removeDevice`,
    method: "post",
    data: params,
  });
};
// 非考勤数据导入
export const importNotAttendanceDevice = (params,id) => {
  return request({
    url: `/device/importNotAttendanceDevice?userId=${id}`,
    method: "post",
    data: params,
    responseType: 'blob'

  });
};
// 考勤数据导入
export const importAttendanceDevice = (params,id) => {
  return request({
    url: `/device/importAttendanceDevice?userId=${id}`,
    method: "post",
    data: params,
    responseType: 'blob'
  });
};
// 终端数据导入
export const importTerminalDevice = (params,id) => {
  return request({
    url: `/device/importTerminalDevice?userId=${id}`,
    method: "post",
    data: params,
  });
};
// 终端EPC导入
export const importEpcDevice = (params,id) => {
  return request({
    url: `/device/importDeviceEpc`,
    method: "post",
    data: params,
  });
};
// 根据IMEI查询设备EPC
export const findDeviceEpc = (imei) => {
  return request({
    url: `/device/findDeviceEpc`,
    method: "get",
    params: { imei },
  });
};
// 修改设备EPC
export const updateDeviceEpc = (params) => {
  return request({
    url: `/device/updateDeviceEpc`,
    method: "post",
    data: params,
  });
};
// 设备详情查找
export const deviceFind = (params) => {
  return request({
    url: `/device/find`,
    method: "get",
    params:params,
  });
};
// 亲情号码导出
export const familyNumberExport = (params) => {
  return request({
    url: `/device/familyNumberExport`,
    method: "post",
    data:params,
    responseType: 'blob'
  });
};
// 修改设备
export const updateInfo = (params) => {
  return request({
    url: `/device/updateInfo`,
    method: "post",
    data:params,
  });
};
// 设备数据报表
export const deviceDataReport = (params) => {
  return request({
    url: `/device/deviceDataReport`,
    method: "post",
    data:params,
    responseType: 'blob'
  });
};
// 日志报表列表
export const statisticalLogList = (params) => {
  return request({
    url: `/statistical/logList`,
    method: "post",
    data:params,

  });
};
// 报警统计报表
export const alarmStatistical = (params) => {
  return request({
    url: `/statistical/alarmStatistical`,
    method: "post",
    data:params,

  });
};
// 通话时长统计
export const callDuration = (params) => {
  return request({
    url: `/statistical/callDuration`,
    method: "post",
    data:params,

  });
};
// 通话记录统计
export const callRecords = (params) => {
  return request({
    url: `/statistical/callRecords`,
    method: "post",
    data:params,

  });
};
// 设备管理报表
export const deviceManagement = (params) => {
  return request({
    url: `/statistical/deviceManagement`,
    method: "post",
    data:params,

  });
};
// 售后管理报表
export const afterSaleManagement = (params) => {
  return request({
    url: `/statistical/afterSaleManagement`,
    method: "post",
    data:params,

  });
};
// 售后管理报表导出
export const afterSaleManagementExport = (params) => {
  return request({
    url: `/statistical/afterSaleManagement/export`,
    method: "post",
    responseType: 'blob',
    data:params,
  });
};
// 售后管理报表导出
export const attendanceMessage = (params) => {
  return request({
    url: `/statistical/attendanceMessage`,
    method: "post",
    data:params,
  });
};
// 服务热线统计报表
export const serviceHotline = (params) => {
  return request({
    url: `/statistical/serviceHotline`,
    method: "post",
    data:params,
  });
};
// 电量统计
export const electric = (params) => {
  return request({
    url: `/statistical/electric`,
    method: "post",
    data:params,
  });
};
// 报警详单报表
export const waringDetails = (params) => {
  return request({
    url: `/statistical/waringDetails`,
    method: "post",
    data:params,
  });
};
// 运动计步报表
export const exerciseStep = (params) => {
  return request({
    url: `/statistical/exerciseStep`,
    method: "post",
    data:params,
  });
};
// /menu/getUserTree 系统用户树//下拉框
export const menuGetUserTree = (params) => {
  return request({
    url:'/menu/getUserTree',
    method:'get',
    params
  })
}
// 获取当前登录人设备型号
export const GetDeviceTree = (params) => {
  return request({
    url:'/menu/getUserById',
    method:'get',
    params
  })
}
// 新增
export const deviceAdd = (params) => {
  return request({
    url:'/device/add',
    method:'post',
    data:params
  })
}
// 用户树
export const setSystemUserTree = (params) => {
  return request({
    url: `/setSystem/userTree`,
    method: "get",
    params:params,
  });
};
// 查询用户下的设备
export const deviceUserDevice = (params) => {
  return request({
    url: `/device/userDevice`,
    method: "get",
    params:params,
  });
};
// 监控平台用户详情
export const deviceDetails = (params) => {
  return request({
    url: `/device/details`,
    method: "get",
    params:params,
  });
};
//获取终端类型
export const menuGetRTree = (params) => {
     return request({
      url: `/menu/getModelTree`,
      method: "get",
      params:params,
   });
  };
  //电量异常统计
  export const dianliangApi = (params) => {
    return request({
      url: `/statistical/electricityAnomalyStatistics`,
      method: "post",
      data:params,
    });
  };
  //用户区域 - 客户树
  export const userTree = (params) => {
    return request({
      url: `/setSystem/userTree`,
      method: "get",
      params:params,
    });
  };
  //用户区域 - 列表
  export const userList = (params,id) => {
    return request({
      url: `/setSystem/userList?userId=${id}`,
      method: "post",
      data:params,
    });
  };
  //设备禁用/启用
  export const deviceRestartJnyong = (deviceId,disable  ) => {
    return request({
      url: `/device/setStatus?deviceId=${deviceId}&disable=${disable  }`,
      method: "post",
    });
  };
//电量异常统计-导出
export const electricity = (params) => {
  return request({
    url: `/statistical/export/electricity`,
    method: "post",
    responseType: 'blob',
    data:params,
  });
};
//设置温度/心率/血氧频率
export const healthOnOffUpdate = (params) => {
  return request({
    url: `/app/heartRate/healthOnOff/update`,
    method: "get",
    params:params,
  });
};
//步数管理
export const healthData = (params) => {
  return request({
    url: `/device/healthData`,
    method: "post",
    data:params,
  });
};
//健康设置查询
export const heartRate = (params) => {
  return request({
    url: `/app/heartRate`,
    method: "get",
    params:params,
  });
};
// 测量心率/体温/血压/血氧
export const measurement = (params) => {
  return request({
    url: `/app/heartRate/measurement`,
    method: "get",
    params:params,
  });
};
// 测量心率/体温/血压/血氧
export const healthDataExport = (params) => {
  return request({
    url: `/device/export/healthData`,
    method: "post",
    responseType: 'blob',
    data:params,
  });
};
// 回显心率/体温/血压/血氧
export const QueryhealthDataExport = (params) => {
  return request({
    url: `/device/query/healthFrequency`,
    method: "get",
    params:params,
  });
};
// 设置心率/体温/血压/血氧
export const setHealthFrequency = (params) => {
  return request({
    url: `/device/setHealthFrequency`,
    method: "get",
    params:params,
  });
};

